/**
 * The Gleamer viewer has no "measurements": annotations are regions belonging to
 * an observation, created and removed through the region flow (the `backspace`
 * "Delete region" hotkey, the annotation panel, the region label editor).
 *
 * Upstream's default context menu offers "Delete measurement" and "Add Label"
 * for any annotation under the cursor — see
 * `extensions/default/src/customizations/defaultContextMenuCustomization.ts`.
 * Those commands act on OHIF's MeasurementService directly, bypassing the
 * observation the region belongs to, so they surfaced on the region flow after
 * the 3.13 merge and were reported in the review (DATAT-482).
 *
 * Registering the same key with no menus removes them without touching upstream.
 *
 * GLEAMER FORK PATCH (re-apply on merge): re-check after every OHIF merge — new
 * default menu entries land here and would surface on regions again.
 */
export default {
  measurementsContextMenu: {
    inheritsFrom: 'ohif.contextMenu',
    menus: [],
  },
};
